import { z } from "zod";
import { isoDateSchema, objectIdSchema } from "./common";
import { registerUserSchema } from "./user";
export const invitationSchema = z.object({
    _id: objectIdSchema,
    createdById: objectIdSchema,
    email: z.string().email().nullable(),
    expiresAt: isoDateSchema,
    usedAt: isoDateSchema.nullable(),
    usedByEmail: z.string().nullable(),
    createdAt: isoDateSchema,
});
export const createInvitationSchema = z.object({
    email: z.string().email().optional(),
});
export const acceptInviteSchema = registerUserSchema.pick({
    name: true,
    password: true,
    timezone: true,
});
export const validateInviteResponseSchema = z.object({
    email: z.string().email().nullable(),
    expiresAt: isoDateSchema,
});
//# sourceMappingURL=invitation.js.map